import { NavLink as BootstrapNavLink } from 'reactstrap';
import styled from 'styled-components';
import Theme from '../modules/Theme';
var NavLink = styled(BootstrapNavLink).withConfig({
  displayName: "NavLink",
  componentId: "sc-1tcorwm-0"
})(["background-color:", ";white-space:nowrap;border-radius:5px;cursor:pointer;"], function (props) {
  return props.active ? Theme.primary : 'inherit';
});
export default NavLink;